import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getWhoami } from 'api/company'
import { QueryOptions } from 'queries/types'
import { whoamiKey } from './keys'

// Use useAuthContext() in components for companies / permissions / company groups
export function useWhoami(
  userId?: string,
  options: QueryOptions<typeof getWhoami> = {}
) {
  return useQuery({
    ...options,
    queryKey: [...whoamiKey, userId],
    queryFn: getWhoami,
    enabled: !!userId,
  })
}

export function useInvalidateWhoami() {
  const queryClient = useQueryClient()

  return {
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: whoamiKey,
      }),
  }
}
